import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectToken } from '../utility/Redux/security';
import {
  selectPrefix,
  selectTableMasterPrefix,
  selectWidth,
} from '../utility/Redux/profile';
import { useState } from 'react';

import axios from 'axios';
import { useEffect } from 'react';
import { useFocus } from '../utility/hooks/hooks';
import {
  setAlertWithTitle,
  setSessionExpired,
  setSpinnerLoading,
} from '../utility/Redux/modal';
import GeniustextInput from '../utility/component/mastertext';
import {
  ModifyButton,
  SaveButton,
  UndoButton,
} from '../utility/component/SNAA_buttons';
import GeniusDatagrid from '../utility/component/datagrid.js/geniusDatagrid';
import { useNavigate } from 'react-router-dom';
import { toProperCase } from '../utility/component/format';
import { CallAPIPromise } from '../utility/func/func';
import { Close, FormatListBulletedRounded, SettingsSuggestOutlined } from '@mui/icons-material';
import './prefixMaster.css';

const Prefixmaster = () => {
  const dispatch = useDispatch();
  const prefix = useSelector(selectPrefix);
  const token = useSelector(selectToken);
  const windowWidth = useSelector(selectWidth);
  const [id, setId] = useState();
  const [textValue, settextValue] = useState();
  const [rows, setRows] = useState([]);
  const [secError, setSecError] = useFocus();

  const columns = [
    {
      field: 'PREFIX_NAME',
      type: 'string',
      renderHeader: (params) => <div>Prefix</div>,
      width: windowWidth > 764 ? 400 : 300,
      headerAlign: 'center',
      align: 'left',
      renderCell: (params) => {
        const runningCaseValue = params.value;
        return <div>{runningCaseValue}</div>;
      },
    },
  ];
  const masterPrefix = useSelector(selectTableMasterPrefix);

  const getData = async () => {
    // dispatch(setSpinnerLoading('Loading'));
    dispatch(setSpinnerLoading('Loading'));
    CallAPIPromise('/api/masters/listPrefixMaster', {
      table_prefix_master: masterPrefix,
    })
      .then((p) => {
        setRows(p.data.response);
      })
      .catch((error) => {
        console.log(error.response.data.name);
        if (error.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
          console.log(error.response);
        }
      })
      .finally(() => {
        setSecError();
        dispatch(setSpinnerLoading(false));
      });
  };

  useEffect(() => {
    getData();
  }, []);
  const saveSectionMasterApi = () => {
    if (textValue) {
      const isDuplicateMobile = rows.some(
        (row) => row.SECTION_NAME === textValue
      );

      if (isDuplicateMobile) {
        dispatch(
          setAlertWithTitle({
            title: 'Information Error!',
            msg: 'This Prefix is already exists. Please choose a different section.',
          })
        );
        return;
      }

      const data = {
        table_prefix_master: masterPrefix,
        CODE: id ? id : '',
        PREFIX_NAME: textValue,
      };

      id
        ? dispatch(setSpinnerLoading('Updating'))
        : dispatch(setSpinnerLoading('Saving'));
      CallAPIPromise(`/api/masters/savePrefixMaster`, data)
        .then(async function (response) {
          dispatch(setSpinnerLoading(false));
          if (!response.data.error) {
            id
              ? dispatch(
                  setAlertWithTitle({
                    title: 'Success.',
                    msg: 'Data Updated successfully.',
                    lottie: 'success',
                  })
                )
              : dispatch(
                  setAlertWithTitle({
                    title: 'Success.',
                    msg: 'Data Saved successfully.',
                    lottie: 'success',
                  })
                );
          } else {
            dispatch(
              setAlertWithTitle({
                title: 'Error 112',
                msg: response.data.error,
              })
            );
            console.log(!response.data.error);
          }
        })
        .catch(function (error) {
          if (error.response.data.name === 'TokenExpiredError') {
            dispatch(setSessionExpired(true));
            console.log(error.response);
          }
          console.log(error);
          dispatch(
            setAlertWithTitle({
              title: 'ERROR',
              msg: 'Something went wrong.',
              lottie: 'reject',
            })
          );
        })
        .finally(() => {
          settextValue('');
          setId('');
          getData();
        });
    } else {
      if (!textValue) {
        dispatch(
          setAlertWithTitle({
            title: 'ERROR',
            msg: 'Please Enter prefix.',
            lottie: 'reject',
          })
        );
        setSecError();
      }
    }
  };
  const navigate = useNavigate();
  return (
    <main className="prefix-master-page">
      <div className="prefix-master-shell">
        <header className="prefix-master-hero">
          <div className="prefix-master-hero__content"><span className="prefix-master-hero__icon"><SettingsSuggestOutlined /></span><div><span>Business setup</span><h1>Prefix Master</h1><p>Manage the prefixes used to identify your business records.</p></div></div>
          <button type="button" onClick={() => navigate('/masters')} aria-label="Back to Masters" title="Back to Masters"><Close fontSize="small" /></button>
        </header>
        <section className="prefix-master-card prefix-master-entry">
          <div className="prefix-master-card__heading"><div><span>Prefix details</span><h2>{id ? 'Update prefix' : 'Create a prefix'}</h2></div><small>{id ? 'Editing selected prefix' : 'New prefix'}</small></div>
          <div id="input" className="prefix-master-entry__body">
            <div className="prefix-master-input">
            <GeniustextInput
              title={'Prefix'}
              width={'100%'}
              type={'text'}
              //   search={handleOpenDeptHelp}
              value={textValue}
              onChange={(e) => {
                settextValue(toProperCase(e.target.value));
              }}
              refrance={secError}
            />
            </div>
            <div className="prefix-master-actions">
              {id ? <ModifyButton onClick={saveSectionMasterApi} /> : <SaveButton onClick={saveSectionMasterApi} />}
              <UndoButton onClick={() => { settextValue(''); setId(''); }} />
            </div>
          </div>
        </section>
        <section className="prefix-master-card prefix-master-table-card">
          <div className="prefix-master-card__heading"><div><span>Saved prefixes</span><h2>Prefix catalogue</h2></div><small className="prefix-master-count"><FormatListBulletedRounded fontSize="small" /> {rows.length} prefixes</small></div>
          <div className="prefix-master-grid">
            <GeniusDatagrid
              rowID={(e) => e.CODE}
              onRowClick={(p) => {
                setId(p.row.CODE);
                settextValue(p.row.PREFIX_NAME);
              }}
              columns={columns}
              list={rows}
            />
          </div>
        </section>
      </div>
    </main>
  );
};

export default Prefixmaster;
